import React, { useState, useEffect, useRef } from "react";

/**
 * Defers rendering of below-the-fold content until the user scrolls near it.
 * Uses IntersectionObserver; falls back to immediate render if unsupported.
 *
 * @param {string} rootMargin - Distance from viewport to start render (default "200px")
 * @param {React.ReactNode} fallback - Placeholder shown before render
 */
export default function LazySection({ children, fallback = null, rootMargin = "200px", className = "" }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    if (typeof IntersectionObserver === "undefined") {
      setVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(true);
            observer.disconnect();
          }
        });
      },
      { rootMargin }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [rootMargin]);

  return (
    <div ref={ref} className={className}>
      {visible ? children : fallback}
    </div>
  );
}